<template>
  <div class="selected-files selected-files_open_select_files">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('file.selectedFiles')"
      :left-text="$t('base.close')"
      :right-text="$t('base.save')"
      @click-left="handleClose"
      @click-right="handleSave"
    />
    <div class="file-list">
      <ul>
        <!-- 搜索结果不同页之间可能重复 这里用下标做key, 用下标作为key 同时上传文件，新文件会获取到原来key的props，导致显示错误 -->
        <li v-for="(item, index) of newSelectedFiles" :key="item.id">
          <file-item
            :item="item"
            scenario="open"
            showDelete
            @delete-item="openHandleDelete(index)"
          />
        </li>
      </ul>
    </div>
    <!-- <div class="menu-header" v-else>
      <div class="has-border-bottom">{{$t('file.selectedFiles')}}</div>
    </div> -->
    <!-- <div class="file-list" v-else>
      <ul>
        搜索结果不同页之间可能重复 这里用下标做key, 用下标作为key 同时上传文件，新文件会获取到原来key的props，导致显示错误
        <li v-for="(item, index) of selectedFiles" :key="item.id">
          <file-item
            :item="item"
            scenario="open"
            showDelete
            @delete-item="handleDelete(index)"
          />
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import FileItem from './FileItem'
export default {
  name: 'SelectedFiles',
  i18n,
  components: {
    FileItem
  },
  model: {
    prop: 'selectedFiles',
    event: 'delete'
  },
  props: {
    selectedFiles: Array,
    show: Boolean
  },
  watch: {
    selectedFiles (newVal) {
      this.newSelectedFiles = newVal
    }
  },
  data () {
    return {
      newSelectedFiles: this.selectedFiles.slice()
    }
  },
  methods: {
    handleDelete (index) {
      const newSelectedFiles = [...this.selectedFiles.slice(0, index), ...this.selectedFiles.slice(index + 1)]
      this.$emit('delete', newSelectedFiles)
    },
    openHandleDelete (index) {
      this.newSelectedFiles = [...this.newSelectedFiles.slice(0, index), ...this.newSelectedFiles.slice(index + 1)]
    },
    handleClose () {
      this.$emit('item-select-toggle')
      this.newSelectedFiles = this.selectedFiles
    },
    handleSave () {
      this.$emit('delete', this.newSelectedFiles)
      this.$emit('item-select-toggle')
    }
  }
}
</script>
<style lang="postcss">
.selected-files {

  & .file-list {
    max-height: 300px;
  }

  & .menu-header {
    background: #fff;
    color: #4b5255;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    padding-left: 20px;

    & div {
      box-sizing: border-box;
      height: 39px;
    }
  }
  &.selected-files_open_select_files{
    height: 100%;
    display: flex;
    flex-direction: column;
    & .file-list {
    flex: 1;
    max-height: none;
   }
  }
}
</style>
